export const updateInArray = <T extends { id?: number }>(
  array: T[],
  payload: T,
) => {
  const item = array.find((item) => item.id === payload?.id);
  if (item) {
    Object.assign(item, payload);
  }
};

export const removeFromArray = <T extends { id: number }>(
  array: T[],
  id: number,
) => {
  const idx = array.findIndex((item) => item.id === id);
  if (idx >= 0) array.splice(idx, 1);
};

export const toTitleCase = (s: string) => {
  return s.toLowerCase().replace(/(?:^|\s|-)\S/g, function (match) {
    return match.toUpperCase();
  });
};
